// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import { Typography, makeStyles } from '@material-ui/core';
import Select from 'react-select';

// Internal Dependencies
import PillButton from '../../common/Button/PillButton';
import Square from '../../common/Square/Square';
import Constants from '../../../common/constants';
import Colours from '../../../styles/colours';
import { useMallMapStore } from '../../../hook/useMallMapStore';

const useStyles = makeStyles(() => ({
  banner: {
    backgroundColor: Colours.ElectricBlue,
    padding:         '10px 20px',
  },
  selectInput: {
    width:   '140px',
    '& div': {
      paddingTop:    '3px',
      paddingBottom: '3px',
    },
  },
}));

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 20,
  }),
};

const typeListOptions = _.map(
  Object.values(Constants.WaypointType),
  (waypoint) => ({ value: waypoint, label: waypoint }),
);

const ManageWaypointBanner = () => {
  const classes = useStyles();
  const { waypointType, setWaypointType } =  useMallMapStore((state) => state);

  return (
    <>
      <div>
        <PillButton className="d-flex align-items-center">
          <Square squareColor={Colours.Primary} />
          <Typography className="mr-2">Add Waypoint. Type:</Typography>
          <Select
            className={classes.selectInput}
            styles={selectStyles}
            name="type"
            options={typeListOptions}
            value={waypointType}
            onChange={(option) => setWaypointType(option)}
          />
        </PillButton>
      </div>
      <div className={classes.banner}>
        <Typography className="font-weight-normal" variant="h6">Right-click anywhere on the map to add Waypoint</Typography>
      </div>
      <div>
        <PillButton text="View Map Legend" />
      </div>
    </>
  );
};

export default ManageWaypointBanner;
